<template>
  <div class="change-live2d">
    <div class="opt">
      <!--宽高-->
      <el-button type="primary" size="small" @click="updateView('shrink')">缩小</el-button>
      <el-button type="primary" size="small" @click="updateView('amplify')">放大</el-button>
      <!--备注：这里上下左右方向相反-->
      <el-button type="primary" size="small" @click="updateView('down')">上</el-button>
      <el-button type="primary" size="small" @click="updateView('up')">下</el-button>
      <el-button type="primary" size="small" @click="updateView('right')">左</el-button>
      <el-button type="primary" size="small" @click="updateView('left')">右</el-button>
      <el-button type="primary" size="small" @click="updateView('save')">保存</el-button>
    </div>
    <div class="position">当前坐标: x: {{ viewport.x }}, y: {{ viewport.y }}</div>
    <div class="view-port">当前视口：宽：{{ viewport.width }}，高：{{ viewport.height }}</div>
    <div class="tips">备注：宽高值越大，展示内容越小，宽高值越小，展示内容越大</div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
import { debounce } from "@/plugins/util";

export default {
  data() {
    return {
      clickCount: 0,
      viewport: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    updateView(type) {
      this.clickCount += 1;
      this.emitUpdateView(type, this.clickCount);
    },
    emitUpdateView: debounce(function(type, count) {
      eventBus.$emit("updateView", type, count);
    }, 600)
  },
  mounted() {
    eventBus.$on("updateViewData", viewData => {
      this.viewport = viewData;
      this.clickCount = 0;
    });
  }
};
</script>

<style scoped lang="less">
.change-live2d {
  position: absolute;
  top: 60px;
  right: 130px;
  z-index: 1000;

  .opt {
    margin-bottom: 10px;
    display: flex;
    column-gap: 10px;
  }

  .view-port {
    margin: 15px 0;
  }

  .tips {
    color: red;
  }
}
</style>
